import AppSwiper from "../../components/common/AppSwiper/AppSwiper";
import "./ArticleCategories.css";

export default function ArticleCategories({
    categories = [],
    selectedCategory = "",
    onCategoryChange,
}) {
    return (
        <section className="article-categories">

            <AppSwiper
                slidesPerView={5}
                spaceBetween={12}

                navigation={false}
                pagination={false}

                allowTouchMove={true}
                simulateTouch={true}

                loop={false}

                direction="rtl"

                className="article-categories-swiper"

                breakpoints={{
                    0: {
                        slidesPerView: 2.2,
                        spaceBetween: 8,
                    },

                    480: {
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                    },

                    768: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                    },

                    1024: {
                        slidesPerView: 8,
                        spaceBetween: 12,
                    },
                }}
            >

                <button
                    type="button"
                    className={
                        !selectedCategory
                            ? "article-category article-category--active"
                            : "article-category"
                    }
                    onClick={() =>
                        onCategoryChange(null)
                    }
                >
                    همه مقالات
                </button>


                {categories.map((category) => {

                    const active =
                        String(selectedCategory) ===
                        String(category.id);

                    return (
                        <button
                            key={category.id}
                            type="button"
                            className={
                                active
                                    ? "article-category article-category--active"
                                    : "article-category"
                            }
                            onClick={() =>
                                onCategoryChange(
                                    String(category.id)
                                )
                            }
                        >
                            {category.title}
                        </button>
                    );
                })}

            </AppSwiper>

        </section>
    );
}